import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  catalogStartDelete,
  selectCatalogs,
  startLoadingCatalogsPaginated,
  startLoadingCatalogsPaginatedByFilters,
  startSearchingCatalogPaginated,
} from "../../app/actions/catalogActions";
import NavbarIconsCatalogs from "../generic-nav-bar/NavbarIconsCatalogs";
import Pagination from "../generic-ui/Pagination";
import SimpleSelect from "../generic-ui/Select";
import { useTranslation } from "react-i18next";
import { useTracking } from "react-tracking";
import { startLoadingCatalogTypes } from "../../app/actions/catalogTypeActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import SearchBackCatalog from "./SearchBackCatalog";
import TableCatalogs from "./TableCatalogs";

const ID_FORM = "admin-catalog";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListCatalogs = () => {
  debugLogPages(':: ListCatalogs');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, catalogsS, catalogsP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.catalog);

  const { catalogTypes } =
    useSelector((state) => state.catalogType);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  const [isDisabledSearchText, setIsDisabledSearchText] = useState(false);
  const [isDisabledFilter, setIsDisabledFilter] = useState(false);


  const [catalogTypeFilter, setCatalogTypeFilter] = useState("");

  useEffect(() => {
    dispatch(startLoadingCatalogsPaginated(pageInitial, itemsPerPage));
    dispatch(startLoadingCatalogTypes());
    setSearchText("");
  }, []);

  useEffect(() => {
    dispatch(startLoadingCatalogTypes());
  }, [])

  const onEditRow = (row) => {
    trackEvent({ component: "EditCatalogs", method: "onEditRow", event: "EditCatalogs-Clicked" });

    dispatch(selectCatalogs(row));
    if (catalogsS && catalogsS.length && catalogsS.length > 0) {
      navigate("/admin-catalog/edit-catalog", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-catalog/edit-catalog");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteCatalogs", method: "onDeleteRow", event: "DeleteCatalogs-Clicked" });
    dispatch(catalogStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {

    if (catalogsS && catalogsS.length > 0) {
      dispatch(startSearchingCatalogPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {

      if (catalogTypeFilter) {
        dispatch(startLoadingCatalogsPaginatedByFilters(pageClick - 1, itemsPerPage, catalogTypeFilter.id));
      } else {
        dispatch(startLoadingCatalogsPaginated(pageClick - 1, itemsPerPage));
      }

    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (catalogsS && catalogsS.length > 0) {
      dispatch(startSearchingCatalogPaginated(searchText, 0, event.target.value));
    } else {
      if (catalogTypeFilter) {
        dispatch(startLoadingCatalogsPaginatedByFilters(0, event.target.value, catalogTypeFilter.id));
      } else {
        dispatch(startLoadingCatalogsPaginated(0, event.target.value));
      }

    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  const handleChangeCatalogType = (event) => {
    if (event != null) {
      setCatalogTypeFilter(event)

      dispatch(startLoadingCatalogsPaginatedByFilters(pageInitial, itemsPerPage, event.id));
      setIsDisabledSearchText(true);
      setIsDisabledFilter(false);

    } else {
      setCatalogTypeFilter("")
      dispatch(startLoadingCatalogsPaginated(pageInitial, itemsPerPage));
      setIsDisabledSearchText(false);
      setIsDisabledFilter(false);
    }
  };

  debugLogPages(":: ListCatalogs, catalogsS", {catalogsS})

  return (
    <>
      <NavbarIconsCatalogs page={"listCatalogs"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <div className="container">
        <div className="row">

          {/* catalogCiiuId */}
          {/* Level1 */}
          <div className="col-md-4">
            <label className="form-label label-information">{t(`${ID_FORM}.filter.level1`)}</label>
            <div className="control">
              <Select
                styles={customStyles}
                myFontSize="14px"
                onChange={handleChangeCatalogType}
                classNamePrefix="select"
                name="catalogTypeFilter"
                value={catalogTypeFilter}
                options={catalogTypes}
                getOptionLabel={(option) => `${option.name} - ${option.description}`}
                getOptionValue={(option) => `${option}`}
                isClearable={true}
                isSearchable={true}
                isDisabled={isDisabledFilter}
              />
            </div>
          </div>

        </div>
      </div>

      <SearchBackCatalog
        searchText={searchText}
        setSearchText={setSearchText}
        itemsPerPage={itemsPerPage}
        setIsDisabledSearchText={setIsDisabledSearchText}
        isDisabledSearchText={isDisabledSearchText}
        setIsDisabledFilter={setIsDisabledFilter}
        isDisabledFilter={isDisabledFilter}
      />


      {catalogsS && catalogsS.length && catalogsS.length > 0 ? (
        <TableCatalogs data={catalogsS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableCatalogs data={catalogsP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <SimpleSelect listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {catalogsS && catalogsS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1}
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListCatalogs;
